import React, { useState } from "react";
import { Link } from "react-router-dom";

function TrackOrder() {
  const [showDetails, setShowDetails] = useState(false);
  const [generatedOrderNumber] = useState(
    `#${Math.floor(10000 + Math.random() * 90000)}`
  );

  const estimatedDelivery = (() => {
    const date = new Date();
    date.setDate(date.getDate() + 4);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  })();

  const steps = [
    "Order Placed",
    "Processing",
    "Packed",
    "Out for Delivery",
    "Delivered",
  ];

  // Random current step between 1–4
  const currentStep = Math.floor(Math.random() * 4) + 1;

  const randomItems = [
    { name: "HP LaserJet Toner", price: 49.99, qty: 1 },
    { name: "Canon Photo Paper", price: 12.99, qty: 2 },
  ];

  return (
    <div className="track-wrapper">
      <div className="container">
        <h2 className="title">Track Your Order</h2>

        {/* Step 1: Input UI */}
        {!showDetails && (
          <div className="track-card">
            <p>Enter your order number to check delivery status</p>

            <input type="text" className="track-input" placeholder="#12345" />

            <button className="th-btn" onClick={() => setShowDetails(true)}>
              Track Order
            </button>

            <Link className="back-link" to="/shop">
              ← Continue Shopping
            </Link>
          </div>
        )}

        {/* Step 2: Show Tracking Details */}
        {showDetails && (
          <>
            <div className="order-box">
              <p>Order Number</p>
              <strong className="order-code">{generatedOrderNumber}</strong>
            </div>

            {/* Progress Timeline */}
            <div className="timeline">
              {steps.map((step, i) => (
                <div
                  key={i}
                  className={`timeline-step ${i <= currentStep ? "done" : ""}`}
                >
                  <div className="circle">{i < currentStep ? "✔" : i + 1}</div>
                  <span>{step}</span>
                </div>
              ))}
            </div>

            {/* Delivery Box */}
            <div className="delivery-box">
              <h4>Estimated Delivery</h4>
              <p className="date">{estimatedDelivery}</p>
              <p className="hint">Your order is on its way 🚚</p>
            </div>

            {/* Summary */}
            <div className="summary">
              <h4>Order Summary</h4>

              {randomItems.map((item, index) => (
                <div key={index} className="summary-item">
                  <span>
                    {item.name} × {item.qty}
                  </span>
                  <strong>${(item.price * item.qty).toFixed(2)}</strong>
                </div>
              ))}

              <div className="total">
                <span>Total Paid</span>
                <strong>
                  $
                  {randomItems
                    .reduce((a, b) => a + b.price * b.qty, 0)
                    .toFixed(2)}
                </strong>
              </div>
            </div>

            <div className="btn-row">
              <Link className="th-btn" to="/my-account">
                Back to Account
              </Link>
              <Link className="th-btn style2" to="/shop">
                Continue Shopping
              </Link>
            </div>
          </>
        )}
      </div>

      {/* Styling */}
      <style>{`
        .track-wrapper { background:#f7f9fc; padding:60px 0; text-align:center; }
        .title { font-size:32px;font-weight:700;margin-bottom:25px; }

        .track-card{
          background:#fff;padding:25px;border-radius:14px;box-shadow:0 5px 18px rgba(0,0,0,0.05);
          max-width:420px;margin:0 auto;
        }
        .track-input{
          width:100%;padding:14px;border-radius:10px;border:1px solid #ccc;
          font-size:18px;text-align:center;margin-bottom:12px;
        }

        .back-link{display:block;margin-top:10px;font-size:14px;color:#0b61d6;text-decoration:none;}

        .order-box{
          background:#fff;padding:18px;border-radius:12px;margin-bottom:30px;
          box-shadow:0px 5px 18px rgba(0,0,0,0.05);
        }
        .order-code{
          margin-top:8px;font-size:22px;padding:6px 18px;background:#eaf6ff;
          color:#0b61d6;border-radius:10px;font-weight:700;
        }

        /* Tracking Timeline */
        .timeline{display:flex;justify-content:space-between;margin:40px 0;position:relative;padding:0 10px;}
        .timeline-step{text-align:center;flex:1;color:#777;}
        .timeline-step.done span{font-weight:600;color:#0b61d6;}

        .timeline-step .circle{
          width:40px;height:40px;border-radius:50%;background:#ccc;color:white;
          display:flex;align-items:center;justify-content:center;margin:0 auto 8px;font-weight:600;
        }
        .timeline-step.done .circle{background:#0b61d6;}

        .timeline::before{
          content:"";position:absolute;top:20px;left:25px;right:25px;height:4px;background:#d4dcec;z-index:-1;
        }

        .delivery-box{
          background:#fff;padding:22px;border-radius:14px;margin-bottom:25px;
          box-shadow:0px 6px 18px rgba(0,0,0,0.05);
        }
        .date{font-size:22px;font-weight:700;color:#0b61d6;margin-top:8px;}

        .summary{
          background:#fff;padding:22px;border-radius:14px;margin-bottom:30px;
          box-shadow:0px 6px 18px rgba(0,0,0,0.05);text-align:left;max-width:650px;margin:auto;
        }
        .summary-item{display:flex;justify-content:space-between;padding:7px 0;}
        .total{border-top:1px solid #ddd;padding-top:12px;font-size:18px;font-weight:700;display:flex;justify-content:space-between;}

        .btn-row{display:flex;justify-content:center;gap:15px;margin-top:25px;}
        .th-btn{
          background:#0b61d6;color:white;padding:14px 26px;border-radius:10px;
          text-decoration:none;font-weight:600;
        }
        .th-btn.style2{
          background:#fff;border:2px solid #0b61d6;color:#0b61d6;
        }
      `}</style>
    </div>
  );
}

export default TrackOrder;
